import React from 'react';
import ReturnAndLossRouter from './ReturnAndLossRouter';

export default function ReturnAndLossPage() {
  return <ReturnAndLossRouter />;
}
